module.exports = __webpack_public_path__ + "img/firestone.21a5c5e5.png";